import { RouterView } from "vue-router";
import { ProcessConfigRouting } from "./process-config/process-config.routing";

export const ProcessManageRouting = {
  path: "/process-manage",
  name: "process-manage",
  redirect: "/process-manage/config/list",
  component: RouterView,
  meta: { title: "流程管理", icon: "process" },
  children: [...ProcessConfigRouting],
};
